'use client';

import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function ({ params: { lang } }) {
  const router = useRouter();

  if (lang !== 'en-US') {
    return (
      <div className="h-fit w-full dark:bg-gray-800">
        <div className="protocol mx-auto max-w-5xl px-6 pb-10 dark:text-gray-400">
          <div
            className="absolute left-1 top-8 flex cursor-pointer items-center text-2xl hover:opacity-80"
            onClick={() => router.back()}
          >
            <ChevronLeftIcon className="w-14" />
            <span className="-ml-1 hidden lg:block">返回</span>
          </div>
          <h2 className="px-6 py-10 text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-400">
            泽科巴隐私政策
          </h2>
          <p>
            感谢您使用泽科巴！
            <b>
              为了更好的保护您的个人信息，建议您仔细阅读《泽科巴隐私政策》，尤其是以黑色加粗的条款。如您对本隐私政策条款有任何异议或疑问，您可通过本《泽科巴隐私政策》第六条“联系我们”中公布的联系方式与我们沟通。
            </b>
          </p>

          <h3>一、引言</h3>
          <p>
            1.1《泽科巴隐私政策》（以下称“本隐私政策”）适用于泽科巴运营的网站、手机客户端、小程序产品以及供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）。泽科巴指上海泽科巴科技有限公司（以下称“泽科巴”或“我们”）。
          </p>
          <p>
            <b>
              1.2.
              请您在使用泽科巴各项产品/服务前，仔细阅读并充分理解本隐私政策的全部内容。一旦您使用或继续使用泽科巴的产品/服务，即表示您同意我们按照本隐私政策使用和处理您的相关信息。
            </b>
          </p>
          <p>
            <b>
              1.3.
              我们可能会不时依据法律法规或业务调整对本隐私政策进行修订。当本隐私政策发生变更后，我们会在版本更新后通过在显著位置提示或推送通知、消息等形式向您展示变更后的内容。
            </b>
          </p>
          <p>
            <b>
              1.4.
              您需理解，只有在您确认并同意变更后的《泽科巴隐私政策》，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，可能导致您不能或不能继续完整使用泽科巴的相关服务和功能，或者无法达到我们拟达到的服务效果。
            </b>
          </p>

          <h3>二、我们如何收集和使用您的个人信息</h3>
          <p>
            2.1.
            泽科巴依据法律法规以及遵循正当、合法、必要的原则而收集和使用您在使用服务过程中主动提供或由于产品/服务需要而产生的个人信息。如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的方式向您告知，并在使用前再次征得您的同意。
          </p>
          <p>
            2.2. 通常情况下，我们会在以下场景中收集和使用您的个人信息：
            <span>
              <b>2.2.1 账号注册与登录</b>
            </span>
            <span>
              <b>
                （1）您注册/登录泽科巴账号时，需要按照我们的指引完成一系列注册/登录程序，在此过程中，您需要向我们提供以下信息：手机号码或电子邮箱（敏感个人信息，用于接受验证码匹配个人身份）。您只有提供真实准确的上述信息，才能成功注册/登录泽科巴账号并使用产品/服务的核心功能。如果您选择不提供上述为实现泽科巴核心产品功能的必备信息，或将导致我们无法为您提供该核心产品功能。
              </b>
            </span>
            <span>
              （2）我们的产品支持您使用第三方平台的账号（微信账号）进行登录，如您使用第三方平台的账号登录的，
              <b>
                我们将根据您的授权获取该第三方账号下的相关信息（包括：用户ID、昵称、头像）以及身份验证信息（敏感个人信息）。
              </b>
              我们承诺，收集上述信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类信息，则您将无法使用第三方平台的账号登录我们平台，但不影响我们提供的其他产品/服务的正常使用。
            </span>
            <span>
              （3）同时，您需理解，手机号码或电子邮箱地址和验证码匹配结果属于您的敏感个人信息，我们收集该类信息是基于法律法规的相关要求，如您拒绝提供可能导致您无法注册/登录账号并使用相关产品功能，请您谨慎考虑后再选择是否提供。
            </span>
            <b>
              <span>2.2.2 邀请</span>
              <span>
                当您在我们的产品中使用邀请功能时，我们需要收集您的一些信息，其中包括如下个人信息：您的设备信息、您的日志信息、您的互联网协议（IP）地址归属地信息，我们收集这些信息是为了验证邀请操作的真实性，同时亦为了改进我们的产品/服务。
              </span>
            </b>
            <span>2.2.3 客户服务</span>
            <span>
              当您向泽科巴发起投诉、申诉或进行咨询时，为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。
              <b>
                同时，为了方便与您联系或帮助您解决问题，我们可能还需要您提供以下敏感个人信息：姓名、手机号码、电子邮件及其他联系方式、所在城市/地区信息。
              </b>
            </span>
            <span>
              <b>
                另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您的需求相关联的其他必要信息。
              </b>
              我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。
            </span>
            <b>
              <span>2.2.4 支付</span>
              <span>
                当您在泽科巴上订购商品/服务、购买积分等发生支付行为时，需要使用到支付功能。在支付过程中，我们可能会收集您的第三方支付渠道的user
                ID（例如支付宝user ID、微信open ID、QQ钱包open
                ID或银行卡信息）（敏感个人信息）。此外，为保障您的账户和资金安全以及支付服务的安全稳定运行，履行反电信网络诈骗等法定义务，我们可能会收集您必要的设备信息（例如IP地址）并提供给您选择的第三方支付渠道。上述信息为我们向您提供商品和/或服务购买功能所必需的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。
              </span>
            </b>
          </p>
          <p>
            <span>2.3. 除上述情况外，我们还可能在以下场景收集和使用您的个人信息：</span>
            <b>
              <span>2.3.1 从第三方间接收集的您的个人信息</span>
            </b>
            <span>
              （1）
              <b>
                您理解并知悉，您向外部第三方提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式（如：恶意干预对方系列APP数据）擅自以软件程序获得您的个人信息。
              </b>
              泽科巴可能因业务发展的需要而确实需要从第三方间接收集（如共享等）您的个人信息的，且由我们直接或共同为您提供产品或服务的，我们（或第三方）在收集前会向您明示共享的您个人信息的来源、类型、使用目的、方式和所用于的业务功能、授权同意范围（如果使用方式和范围超出您在第三方原授权范围的，我们会再次征得您的授权同意）。
            </span>
            <span>
              （2）我们的专业安全团队对个人信息将进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。
            </span>
            <span>
              <b>2.3.2 消息通知与营销推广</b>
            </span>
            <span>
              <b>
                我们可能会通过您在使用产品/服务过程中所提供的联系方式（如电话号码），向您发送一种或多种类型的通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研；此外，我们也可能会通过短信、电话的方式向您提供您可能感兴趣的服务、功能或活动等商业性信息。
              </b>
              如您不愿接收我们的商业性信息，您可联系我们退订
              <b>（本《泽科巴隐私政策》第六条“联系我们”）</b>。
            </span>
            <b>
              <span>2.3.3 出于其他合理且必要的目的</span>
              <span>
                如果某一需要收集您的个人信息的产品/服务未能在本隐私政策中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们将在收集和使用您的个人信息前，通过更新本隐私政策、页面提示、弹窗、网站公告或其他便于您获知的方式另行向您说明，并为您提供自主选择同意的方式，且在征得您明示同意后收集和使用。
              </span>
            </b>
            <span>
              <b>2.3.4 依法豁免征得同意的情形</b>
            </span>
            <span>
              <b>您理解并同意，在以下情况下，我们无需取得您的授权同意即可收集和使用您的个人信息：</b>
            </span>
            <span>（1）为订立、履行我们与您签署的合同所必需；</span>
            <span>
              （2）为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；
            </span>
            <span>（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span>
            <span>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span>
            <span>（5）在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</span>
            <span>（6）法律法规规定的其他情形。</span>
          </p>

          <h3>三、个人信息的保护</h3>
          <p>
            3.1.
            <b>我们承诺，不会与任何公司、组织、个人共享您的个人信息。</b>
            您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。
          </p>
          <p>
            <b>
              3.2.
              安全技术措施：我们使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
            </b>
          </p>
          <p>
            3.3.
            除获取您的明示同意外，我们不会将您的个人信息转让给任何公司、组织或个人。如因合并、收购或破产清算的情形需要转移您的个人信息，我们会向您告知接收方的名称或者姓名，并要求接收方继续受本隐私政策的约束。如接收方变更本隐私政策中约定的个人信息处理目的、处理方式，我们将要求接收方重新获取您的授权同意。
          </p>
          <p>
            3.4.
            除符合法律法规的规定进行公开披露或获得您单独同意外，我们不会公开披露您未自行公开或者其他未合法公开的个人信息。如需公开披露您的个人信息，我们会提前进行个人信息保护影响评估，并采用符合行业内标准的安全保护措施和手段保护您的个人信息安全。
          </p>
          <p>
            <b>
              3.5.
              请您知悉，根据法律法规的规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
              <span>3.5.1 为订立、履行我们与您签署的合同所必需；</span>
              <span>
                3.5.2
                为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；
              </span>
              <span>3.5.3 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span>
              <span>3.5.4 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span>
              <span>3.5.5 在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</span>
              <span>3.5.6 法律法规规定的其他情形。</span>
            </b>
          </p>
          <p>
            您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能出现我们可控范围外的安全问题。因此，我们
            <b>
              强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。
            </b>
          </p>

          <h3>四、关于使用Cookie和同类技术</h3>
          <p>
            4.1.
            在您使用我们的产品/服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，包括：您访问网站的习惯、您的浏览信息、您的登录信息，Cookie和同类技术收集该类信息是为了您使用我们的产品/服务的必要、简化您重复操作的步骤（如注册、登录）、便于您查看使用历史、向您提供更切合您个人需要的服务内容和您可能更感兴趣的内容、保护您的信息和账号安全性、提升我们的产品/服务等。
          </p>
          <p>
            4.2.
            如果您拒绝我们使用Cookie及同类技术收集和使用您的相关信息，您可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、（部分/全部）拒绝Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而实现我们无法全部或部分追踪您的个人信息。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。
            <b>
              您理解并知悉：我们的某些产品/服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品/服务或无法通过我们的产品/服务获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。
            </b>
          </p>

          <h3>五、我们对未成年人的个人信息保护</h3>
          <p>
            5.1. 未成年人使用我们的产品/服务前应取得其监护人的同意。
            <b>
              如您为未成年人，在使用我们的产品/服务前，应在监护人监护、指导下共同阅读本隐私政策且应在监护人明确同意和指导下使用我们的产品/服务、提交个人信息。
            </b>
            我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人明确同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息。
          </p>
          <p>
            5.2.
            若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，您可以通过本隐私政策第六条“联系我们”中公示的联系方式与我们沟通解决。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会尽快删除相关数据。
          </p>

          <h3>六、联系我们</h3>
          <p>
            6.1.
            如您对本《泽科巴隐私政策》的内容或使用我们的服务时遇到的与隐私保护相关的事宜有任何疑问或进行咨询或投诉时，您均可以通过向我们开通的support@zecoba.com客服邮箱发送邮件与我们联系；
          </p>
          <p>
            6.2. 我们会在收到您的意见及建议后，尽快向您回复。
            <b>此外，您理解并知悉，在与个人信息有关的如下情形下，我们将无法回复您的请求：</b>
            <b>
              <span>6.2.1 与国家安全、国防安全有关的；</span>
              <span>6.2.2 与公共安全、公共卫生、重大公共利益有关的；</span>
              <span>6.2.3 与犯罪侦查、起诉和审判等有关的；</span>
              <span>6.2.4 有充分证据表明您存在主观恶意或滥用权利的；</span>
              <span>6.2.5 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
              <span>6.2.6 涉及商业秘密的；</span>
              <span>6.2.7 法律法规等规定的其他情形。</span>
            </b>
          </p>

          <h3>七、本政策如何更新</h3>
          <p>
            为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本《隐私政策》的条款，该等更新构成本《隐私政策》的一部分。未经您明确同意，我们不会削减您按照本政策所应享有的权利。
            <b>
              我们将在更新后的本隐私政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，如该等更新造成您在本隐私政策下权利的实质减少或重大变更，我们会再次征求您的明示同意。
            </b>
          </p>

          <h3>八、争议解决</h3>
          <p>
            <b>
              8.1.
              本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，您同意向上海仲裁委员会提起仲裁解决；该仲裁一裁终局，对双方均具有法律约束力。
            </b>
          </p>
          <p>8.2. 如果您认为我们处理个人信息的行为损害了您的合法权益，您也可以选择向有关政府部门进行反映。</p>
          <p>8.3. 本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。</p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="h-fit w-full dark:bg-gray-800">
        <div className="protocol mx-auto max-w-5xl px-6 pb-10 dark:text-gray-400">
          <div
            className="absolute left-1 top-8 flex cursor-pointer items-center text-2xl hover:opacity-80"
            onClick={() => router.back()}
          >
            <ChevronLeftIcon className="w-14" />
            <span className="-ml-1 hidden lg:block">Back</span>
          </div>
          <h2 className="px-6 py-10 text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-400">
            Privacy Policy
          </h2>
          <p>
            This Privacy Policy explains how we collect, use, disclose, and otherwise process your personal information
            on our website and other places where Zecoba may act as a data controller and link to this Privacy
            Policy—for example, where you use Zecoba’s APIs or other products as a consumer for personal use (“
            <b>Services</b>”). It does not apply to personal information we receive, process, store, or host when you
            use Zecoba’s AI services as or through an enterprise customer, unless otherwise specified in this policy. In
            those cases, you interact with us through the enterprise customer company, and you can review their privacy
            policy for more information about how they handle your personal information.
          </p>

          <h3>1. Collection of Personal Information</h3>
          <p>
            We collect the following categories of personal information when you interact with our Services, including
            if you have an Zecoba account on our Services. We need this data to provide you with our Services, which may
            allow you to use our API or interact with our AI services via various interfaces.
          </p>
          <p>
            <b>
              <i>Personal information you provide to our website</i>
            </b>
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
            <li>
              <b>Identifiers</b>: Zecoba may collect identifiers, such as your name and email when you sign up for an
              Zecoba account, to receive information on our Services, or submit an application for an employment
              opportunity. If you do not provide us with this information, we will not be able to administer your Zecoba
              account. We may also collect indirect identifiers (e.g., “USER123456”).
            </li>
            <li>
              <b>Financial Information</b>: We will collect your payment information if you choose to purchase access to
              Zecoba’s products and services through the Services. If you do not provide us with this information, we
              will not be able to facilitate the purchase of Zecoba’s products and services.
            </li>
            <li>
              <b>Professional Information</b>: If you use our Services to apply for employment, Zecoba may collect
              professional information that you give us, such as your résumé.
            </li>
            <li>
              <b>Internet or other electronic network activity information</b>: When you use our AI services, we collect
              your Prompts in order to generate Results (as defined in our Terms of Use), which may be associated with
              identifiers relating to you. If you include personal information in your Prompts, we will also process
              that information. Note, however, that Prompts and Results are subject to strict retention periods, as set
              out below in Section 7.
            </li>
            <li>
              <b>Feedback on your use of our Services</b>: Where applicable, we will collect your Feedback (as defined
              in our Terms of Use) regarding Prompts and Results and use it to train and improve our Services.
            </li>
          </ul>
          <p>
            <b>
              <i>Personal information we receive automatically from your use of the website</i>
            </b>
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
            <li>Internet or other electronic network activity information, including your device type;</li>
            <li>IP address (including information about the location of the device derived from your IP address);</li>
            <li>
              Device or advertising identifiers, probabilistic identifiers, and other unique personal or online
              identifiers;
            </li>
            <li>
              Information about your device and operating system, such as time zone setting and location, operating
              system and platform;
            </li>
            <li>
              Information about your browser, such as browser type and version, browser plug in types and versions;
            </li>
            <li>Internet service provider;</li>
            <li>
              Pages that you visit before and after the website, browsing history, search history, and the date and time
              of your visit;
            </li>
            <li>
              Information about the links you click, pages you view, and advertising you interact with within the
              website and other information about how you use the Services;
            </li>
            <li>The technology on the devices you use to access the Services; and</li>
            <li>Standard server log information.</li>
          </ul>
          <p>
            If you or your device experiences an error, we may collect information about the error, the time the error
            occurred, the feature being used, the state of the application when the error occurred, and any
            communications or content provided at the time the error occurred.
          </p>
          <p>
            In these contexts, Zecoba receives personal information from the following categories of sources: directly
            from you, such as when you interact with the Zecoba website, and from internet service providers.
          </p>

          <h3>2. Cookies & Similar Technologies</h3>
          <p>
            We and our service providers use cookies, scripts, or similar technologies to manage the Services and to
            collect information about you and your use of the Services. These technologies help us to recognize you,
            customize or personalize your experience, offer additional products or services to you, and analyze the use
            of our Services to make it more useful to you.
          </p>
          <p>
            These technologies may also allow us to collect demographic and statistical data and provide this
            information to our service providers to help deliver their services. Most internet browsers allow you to
            remove or manage cookie functions and adjust your privacy and security preferences. For information on how
            to do this, access the “help” menu on your internet browser, or access{' '}
            <Link
              className="text-blue-600 hover:opacity-80 dark:text-blue-500"
              href="https://www.aboutcookies.org/how-to-control-cookies"
            >
              https://www.aboutcookies.org/how-to-control-cookies
            </Link>
            .
          </p>
          <p>
            Please note, however, that disabling our cookies may mean that you may not be able to take full advantage of
            our Services.
          </p>

          <h3>3. Uses of Personal Information</h3>
          <p>Zecoba uses your personal information for the following business purposes:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
            <li>
              <b>To provide and facilitate the Services</b>, including to fulfill any contracts with you with respect to
              your Zecoba account.
            </li>
            <li>
              <b>For our legitimate business purposes or with your consent</b>, as applicable, including:
              <ul style={{ listStyleType: 'circle', paddingLeft: '1em' }}>
                <li>
                  To communicate with you, including by sending you emails, push notifications, and other messages.
                </li>
                <li>To review and consider your application for employment with Zecoba, if you choose to apply.</li>
                <li>To create and administer your Zecoba account.</li>
                <li>To facilitate payments for products and services provided by Zecoba.</li>
                <li>
                  To prevent and investigate fraud notifications, unlawful or criminal activity, unauthorized access to
                  or use of personal information or Zecoba systems and networks, and to meet governmental and
                  institutional policy obligations.
                </li>
                <li>To investigate and resolve disputes and security issues.</li>
                <li>To debug to identify and repair errors that impair existing functionality.</li>
                <li>
                  To enforce our Terms of Service and similar terms and agreements, including our Acceptable Use Policy.
                </li>
                <li>To improve the Services and our other products and services.</li>
                <li>For other business purposes at your direction or with your consent.</li>
              </ul>
            </li>
            <li>
              <b>To comply with applicable laws, rules, and guidance</b>, including those related to AI systems.
            </li>
          </ul>

          <h3>4. How We Disclose Personal Information</h3>
          <p>
            Zecoba will disclose personal information to the following categories of third parties for business
            purposes:
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
            <li>
              <b>Affiliates & corporate partners</b>. Zecoba discloses the categories of personal information described
              above between and among its affiliates and related entities.
            </li>
            <li>
              <b>Service providers & business partners</b>. Zecoba may disclose the categories of personal information
              described above with service providers and business partners for a variety of business purposes, including
              website and data hosting, ensuring compliance with industry standards, research, auditing, and data
              processing.
            </li>
          </ul>
          <p>Zecoba may also disclose personal information in the following circumstances:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
            <li>
              <b>As part of a significant corporate event</b>. If Zecoba is involved in a merger, corporate transaction,
              bankruptcy, or other situation involving the transfer of business assets, Zecoba will disclose your
              personal information as part of these corporate transactions.
            </li>
            <li>
              <b>To comply with regulatory or legal requirements, safety and terms enforcement</b>. We may disclose
              personal information to governmental regulatory authorities as required by law, including for tax or
              accounting purposes, in response to their requests for such information or to assist in investigations. We
              may also disclose personal information to third parties in connection with claims, disputes or litigation,
              when otherwise required by law, or if we determine its disclosure is necessary to protect the health and
              safety of you or any other person, to protect against fraud or credit risk, or to enforce our legal rights
              or contractual commitments that you have made.
            </li>
            <li>
              <b>With an individuals’ consent</b>. Zecoba will disclose personal information when an individual gives us
              permission or directs us to disclose this information.
            </li>
          </ul>
          <p>
            If you access third party services, such as social media sites or other sites linked through the Services
            (e.g., if you follow a link to our Twitter account), these third-party services will be able to collect
            personal information about you, including information about your activity on the Services. If we link to a
            site or service via our Services, you should read their data usage policies or other documentation. Our
            linking to another site or service doesn’t mean we endorse it or speak for that third party.
          </p>

          <h3>5. Rights and Choices</h3>
          <p>
            Subject to applicable law, and depending on where you reside, you may have some rights regarding your
            personal information, including the following:
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1em' }}>
            <li>
              <b>Right to know</b>. You may have the right to know what personal information Zecoba has collected about
              you, including the categories of personal information, the categories of sources from which it is
              collected, the business or commercial purposes for collection, and the categories of third parties to whom
              we disclose it.
            </li>
            <li>
              <b>Access & data portability</b>. You may have the right to request a copy of the personal information
              Zecoba processes about you, subject to certain exceptions.
            </li>
            <li>
              <b>Deletion</b>. You may have the right to request that we delete personal information collected from you
              and retained, subject to certain exceptions.
            </li>
            <li>
              <b>Correction</b>. You may have the right to request that we correct inaccurate personal information
              Zecoba retains about you, subject to certain exceptions.
            </li>
            <li>
              <b>Objection</b>. You may have a right to object to some processing activities.
            </li>
            <li>
              <b>Withdrawal of consent</b>. Where Zecoba’s processing of your personal data is based on consent, you may
              have the right to withdraw your consent.
            </li>
            <li>
              <b>Sale & targeted advertising</b>. Zecoba does not “sell” your personal information as that term is
              defined by applicable laws and regulations. Zecoba also does not engage in targeted advertising using your
              personal information. We do not knowingly collect, sell, or share information of consumers between the
              ages of 13 and 16.
            </li>
            <li>
              <b>Do Not Track</b>. Some web browsers provide a “Do Not Track” option. We currently do not respond to
              browser “Do Not Track” signals.
            </li>
          </ul>
          <p>
            To exercise your access, portability, deletion, or correction rights, you or an authorized agent may submit
            a request by emailing us at{' '}
            <Link className="text-blue-600 hover:opacity-80 dark:text-blue-500" href="mailto:privacy@zecoba.com">
              privacy@zecoba.com
            </Link>
            . After we receive your request, we may verify it by requesting information sufficient to confirm your
            identity. You may also have the right to appeal requests that we deny by emailing{' '}
            <Link className="text-blue-600 hover:opacity-80 dark:text-blue-500" href="mailto:privacy@zecoba.com">
              privacy@zecoba.com
            </Link>
            .
          </p>

          <h3>6. Third-Party Websites and Services</h3>
          <p>
            Our Services may involve integrations with, or may direct you to, websites, apps, and services managed by
            third parties. By interacting with these third parties, you acknowledge that you are providing information
            directly to the third party and not Zecoba and subject to the third party’s privacy policy. For example, if
            you use the Services to apply for employment, this could involve an integration with a third party product,
            subject to that third-party product’s privacy policy.
          </p>

          <h3>7. Data Retention</h3>
          <p>
            Zecoba retains your personal information for as long as reasonably necessary for the purposes and criteria
            outlined in this Privacy Policy, except that we delete information you instruct us to delete in accordance
            with Section 5 above. For Services, other than the Zecoba API, we may retain Prompts and Results as needed
            to provide the Service. As an example, if a Service allows you to save and continue conversations, we retain
            the Prompts and Results in order to provide you with a consistent product experience over time.
          </p>
          <p>
            When assessing how long your personal information is retained, we consider criteria such as: (i) the nature
            of the personal information and the activities involved; (ii) when and for how long you interact with
            Zecoba; and (iii) our legitimate interests and our legal obligations. In all cases, we may retain Prompts
            and Results as required by law or as necessary to combat violations of our Acceptable Use Policy.
          </p>

          <h3>8. Changes to Our Privacy Policy</h3>
          <p>
            Zecoba may update this Privacy Policy from time to time. When we make updates, we will post the updated
            Privacy Policy on this page. We encourage you to review this page for updates when you access the Services.
          </p>

          <h3>9. Contact Information</h3>
          <p>
            Contact us via email at{' '}
            <Link className="text-blue-600 hover:opacity-80 dark:text-blue-500" href="mailto:privacy@zecoba.com">
              privacy@zecoba.com
            </Link>
          </p>
        </div>
      </div>
    );
  }
}
